import { de } from './locales/de'
import { en } from './locales/en'
import { es } from './locales/es'
import { fr } from './locales/fr'
import { hr } from './locales/hr'
import { it } from './locales/it'
import { pt } from './locales/pt'

export const resources = {
    hr,
    en,
    de,
    it,
    es,
    pt,
    fr,
}
